<template>
  <div>
    <h1 style="text-align: center">Plataforma</h1>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <p>
          A plataforma circular é usada em indústria química e petroquímica como plataforma de operação e manutenção.
        </p>
        <img src="@/assets/images/img_grade12.jpg" alt="img" class="w-100 img-fluid sec-img" />
        <p style="margin-top: 50px">
          A seta <span><img src="@/assets/images/seta.gif"/></span> ao lado, indica a direção das barras principais e recomenda-se usar uma folga entre painéis de 5mm.
        </p>
      </b-col>
      <b-col sm="12" md="6" style="text-align: center">
        <img src="@/assets/images/img_grade11.jpg" alt="img" width="300" class=" img-fluid sec-img" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Plataforma",
};
</script>
